export function registerGlobalErrorHandlers(): void {
    window.addEventListener('error', (event: ErrorEvent) => {
        // eslint-disable-next-line no-console
        console.error('[GlobalErrorHandler] Unhandled error:', event.error ?? event.message, event);
    });

    window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
        // eslint-disable-next-line no-console
        console.error('[GlobalErrorHandler] Unhandled promise rejection:', event.reason, event);
    });
}